var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrokenImage = function SvgBrokenImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.506 14.167q-.63 0-1.068-.438A1.45 1.45 0 0 1 0 12.66V1.506Q0 .876.438.438A1.45 1.45 0 0 1 1.506 0H12.66q.631 0 1.07.438.436.436.437 1.068V12.66q0 .631-.438 1.07a1.46 1.46 0 0 1-1.069.437zm.577-6.308 3.334-3.333L8.75 7.859l3.333-3.333.834.833V1.506a.25.25 0 0 0-.072-.184.25.25 0 0 0-.185-.072H1.506a.25.25 0 0 0-.184.072.25.25 0 0 0-.072.184v5.52zm-.577 5.058H12.66a.25.25 0 0 0 .185-.072.25.25 0 0 0 .072-.185V7.128l-.834-.833L8.75 9.628 5.417 6.295 2.083 9.628l-.833-.833v3.865a.25.25 0 0 0 .072.185.25.25 0 0 0 .184.072m-.256 0V7.128v1.25V1.25z"
  })));
};
export default SvgBrokenImage;